
    import { computed, defineComponent, onBeforeMount, ref } from 'vue'
    import { DateTime } from 'luxon'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { usePostsStore } from '@/app/stores/posts'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const postsStore = usePostsStore()

            const dates = computed(() => postsStore.dates)
            const luxonDates = computed(() => dates.value.map(date => DateTime.fromFormat(date, 'yyyy-MM-dd')))

            const maxDate = computed((): string => {
                return luxonDates.value.length
                    ? DateTime.max(...luxonDates.value).toFormat('yyyy-MM-dd')
                    : DateTime.local().toFormat('yyyy-MM-dd')
            })

            const minDate = computed((): string => {
                return luxonDates.value.length
                    ? DateTime.min(...luxonDates.value).toFormat('yyyy-MM-dd')
                    : DateTime.local().toFormat('yyyy-MM-dd')
            })

            const date = ref(maxDate.value)
            const formattedDate = computed(() => {
                return DateTime.fromFormat(date.value, 'yyyy-MM-dd').toLocaleString(DateTime.DATE_FULL)
            })

            const dateAllowed = (date: string): boolean => {
                return dates.value.includes(date)
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.breadcrumbs.posts').toString() },
                    { text: i18n.t('nav.breadcrumbs.calendar').toString() }
                ])

                headful({
                    title: `${i18n.t('nav.posts.calendar')} | ${i18n.t('meta.title')}`
                })

                await postsStore.loadDates()
            })

            return {
                date,
                formattedDate,
                maxDate,
                minDate,
                dateAllowed
            }
        }
    })
